var map = {
	"./1. DashboardTeam.png": 6226,
	"./2. EmployeeCard.png": 4764,
	"./3. DashBoardOrganization.png": 1638,
	"./4. DevelopingSkill.png": 9542,
	"./5. PlanFollowUp.png": 3532,
	"./6. Evaluation.png": 8972,
	"./7. Profiling.png": 7001,
	"./8. BetherTool.png": 5968,
	"./9. SuggestedPlan.png": 4169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6007;